import { useState, useRef, useEffect } from 'react';
import STYLES from './BootScreen.module.scss';

const BootScreen = ({ onDismiss }) => {
  const [loadingDesktop, setLoadingDesktop] = useState(false);
  const bootScreenRef = useRef(null);

  const handleBootScreenDismiss = () => {
    setLoadingDesktop(true);
    setTimeout(() => {
      onDismiss();
    }, 1000);
  };

  useEffect(() => {
    const handleKeyDown = () => {
      handleBootScreenDismiss();
    };

    const ref = bootScreenRef.current;

    if (ref) {
      ref.focus();
      ref.addEventListener('keydown', handleKeyDown);
    }

    return () => {
      ref.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  return (
    <div
      tabIndex="0"
      className={loadingDesktop ? STYLES.LoadingDesktop : STYLES.BootScreen}
      onKeyDown={() => handleBootScreenDismiss}
      onClick={handleBootScreenDismiss}
      ref={bootScreenRef}
    >
      {!loadingDesktop && (
        <div className={STYLES.BootScreen__content}>
          <span>C:\>milloy.dev</span>
          <span className={STYLES.BlinkingCursor}>
            Press any key to continue...
          </span>
        </div>
      )}
    </div>
  );
};

export default BootScreen;
